<template>
  <div>
    <v-combobox
      :items="dataVariants"
      style="width: 200px"
      v-model="selectedDataVariant"
      outlined
      height="34"
      dense
      :disabled="fileLoading"
      :loading="fileLoading"
      color="#a9a9a9"
      item-color="#a9a9a9"
    ></v-combobox>
    <apexchart
      ref="apexChart"
      height="400px"
      type="line"
      :options="options"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import moment from "moment";
import numeral from "numeral";

export default {
  name: "ApexChart",
  props: {
    datasets: {
      type: Object,
      required: true,
    },
    dataVariants: {
      type: Array,
      required: true,
    },
    initialDataVariant: {
      type: String,
      required: true,
    },
    fileLoading: {
      type: Boolean,
      default: false,
    },
    dateTrunc: {
      type: String,
      default: "day",
    },
  },
  data: function () {
    return {
      selectedDataVariant: "",

      newOptions: "",
      options: {
        chart: {
          //id: "website-dash-chart",
          redrawOnWindowResize: true,
          width: "100%",
          animations: {
            enabled: true,
            easing: "easeinout",
            speed: 800,
            animateGradually: {
              enabled: true,
              delay: 150,
            },
            dynamicAnimation: {
              enabled: true,
              speed: 350,
            },
          },
        },
        xaxis: {
          show: false,
          type: "datetime",
          labels: {
            datetimeFormatter: {
              year: "yyyy",
              month: "MMM 'yy",
              day: "dd MMM",
              hour: "HH:mm",
            },
          },
          // labels: {
          //   formatter: function (value) {
          //     const formatter = new Intl.DateTimeFormat("en-US", {
          //       day: "2-digit",
          //       month: "short",
          //     });
          //     const formattedDate = formatter.format(value);
          //     return formattedDate;
          //   },
          // },
        },
        stroke: {
          curve: "smooth",
        },
        yaxis: [
          {
            opposite: true,
            showAlways: true,
            title: {
              text: "",
            },
            labels: {
              formatter: function (value) {
                return Math.floor(Math.log10(Math.abs(value))) + 1 > 3
                  ? numeral(value).format("0.0a")
                  : value;
              },
            },
          },
          {
            showAlways: true,
            title: {
              text: "",
            },
            labels: {
              formatter: function (value) {
                return Math.floor(Math.log10(Math.abs(value))) + 1 > 3
                  ? numeral(value).format("0.0a")
                  : value;
              },
            },
          },
        ],
        tooltip: {
          followCursor: true,
          x: {
            format: "dd MMM",
            formatter: function (value) {
              return moment(value).format("DD MMM");
            },
          },
        },
      },
      series: [],
      noData: {
        text: "Loading...",
        align: "center",
        verticalAlign: "middle",
        offsetX: 0,
        offsetY: 0,
        style: {
          color: "#000",
          fontSize: "14px",
        },
      },
    };
  },
  beforeMount() {
    !this.selectedDataVariant
      ? (this.selectedDataVariant = this.initialDataVariant)
      : this.selectedDataVariant;
  },
  methods: {
    updateSelectedDataVariant(variant) {
      this.$emit("update-data-variant", variant);
    },
    updateXTooltipFormat() {
      let format = "";
      let momentFormat = "";

      switch (this.dateTrunc) {
        case "month":
          format = "MMM 'yy";
          momentFormat = "MMM 'yy";

          break;
        case "hour":
          format = "dd MMM - HH:mm";
          momentFormat = "DD MMM - HH:mm";

          break;
        case "day":
        case "week":
          format = "dd MMM";
          momentFormat = "DD MMM";

          break;

        default:
          format = "dd MMM";
          momentFormat = "DD MMM";

          break;
      }

      this.$refs.apexChart.updateOptions({
        tooltip: {
          x: {
            format: format,
            formatter: function (value) {
              return moment(value).format(momentFormat);
            },
          },
        },
      });

      console.log(momentFormat, format, "dcdc");
    },
    updateSeries() {
      let allDatasets = [];

      switch (this.selectedDataVariant) {
        case "Clicks":
          this.$refs.apexChart.updateSeries(this.datasets.clicks);
          break;
        case "Sends":
          this.$refs.apexChart.updateSeries(this.datasets.sends);
          break;
        case "Subs":
          this.$refs.apexChart.updateSeries(this.datasets.subs);
          break;
        case "Deliveries":
          this.$refs.apexChart.updateSeries(this.datasets.deliveries);
          break;
        case "All":
          allDatasets = this.datasets.deliveries.concat(
            this.datasets.clicks,
            this.datasets.sends,
            this.datasets.totals,
            this.datasets.subs
          );
          this.$refs.apexChart.updateSeries(allDatasets);
          break;
        default:
          allDatasets = [];
          allDatasets = this.datasets.deliveries.concat(
            this.datasets.clicks,
            this.datasets.sends
          );
          this.$refs.apexChart.updateSeries(allDatasets);
      }
    },
  },
  watch: {
    dateTrunc: {
      handler() {
        console.log(this.dateTrunc);
        this.updateXTooltipFormat();
        // console.log(
        //   this.dateTrunc,
        //   this.dateTrunc === "hour" ? "dd MMM - HH:mm" : "dd MMM"
        // );
      },
      deep: true,
      immediately: true,
    },
    datasets: {
      handler() {
        this.updateXTooltipFormat();
        this.updateSeries();
      },
      deep: true,
      immediately: true,
    },
    selectedDataVariant: {
      handler(newVariant) {
        this.updateSeries();
        this.updateSelectedDataVariant(newVariant);
      },
      deep: true,
      immediately: true,
    },
  },
};
</script>
